//
// generated from "GameCommon.pd"
//

export enum NET_LENGTH {
  STRING_4_LEN = 4,
  STRING_8_LEN = 8,
  STRING_16_LEN = 16,
  STRING_32_LEN = 32,
  STRING_64_LEN = 64,
  STRING_128_LEN = 128,
  STRING_256_LEN = 256,
  STRING_512_LEN = 512,
  STRING_1024_LEN = 1024,
  USERNO_LEN = 16,
  USERID_LEN = 36,
  USERACCOUNT_LEN = 16,
  USERPWD_LEN = 16,
  PLATFORM_LEN = 32,
  PWDKEY_LEN = 16,
  AUTHKEY_LEN = 64,
  CHARACTERNAME_LEN = 32,
  CHATMSG_LEN = 256,
  ROOMNAME_LEN = 16,
  GAMENAME_LEN = 16,
  ROOMPASSWD_LEN = 36,
  INVENTORY_SLOT_COUNT = 20,
  BAG_SLOT_COUNT = 10,
  PARTS_SLOT_COUNT = 6,
  EQUIPMENT_SLOT_COUNT = 5,
  QUICK_SLOT_COUNT = 5,
  BASE_VALUE_COUNT = 20,
  ITEM_NAME_LEN = 32,
  ITEM_DESC_LEN = 64,
  ITEM_IMAGE_NAME_LEN = 64,
  STACK_MAX_COUNT = 99,
  SERVER_TYPE_LEN = 16,
  SERVER_NAME_LEN = 50,
  IPADDRESS_LEN = 15,
  PORTSTRING_LEN = 10,
  STATUSSTRING_LEN = 10,
  REASONSTR_LEN = 20,
  REPORT_CHAT_COUNT = 50,
  GUID_STRING_LEN = 36,
  UUID_STRING_LEN = 36,
  EMAIL_LEN = 32,
  SESSIONID_LEN = 64,
  CACHEID_LEN = 64,
  NICKNAME_MIN = 2,
  NICKNAME_MAX = 8,
  NICKNAME_LEN = 32,
  CLUBNAME_MIN = 2,
  CLUBNAME_MAX = 8,
  PROFILE_LEN = 256,
  ORIGIN_NAME_LEN = 32,
  IAB_CODE_LEN = 512,
  GOOGLE_AUTH_TOKEN_LEN = 128,
  GOOGLE_AUTH_EMAIL_LEN = 40,
  GCM_REGISTER_LEN = 256,
  GCM_DEVICEID_LEN = 64,
  COUPON_LEN = 64,
  REASON_TEXT_LEN = 128,
  DATETIME_LEN = 64,
  COMMAND_TITLE_LEN = 128,
  COMMAND_MESSAGE_LEN = 256,
}

export enum NET_SYNC_STATE {
  NONE = 0,
  REQUESTED = 1,
  RECEIVED = 2,
  PROCESSED = 3,
}

export enum NETGAMETYPE {
  UNKNOWN = 0,
  ADVENTURER = 1,
}

export enum ACCOUNT_STATE {
  REGISTERED = 0,
  UNREGISTERED = 1,
  BLOCKED = 2,
}

export enum ACCOUNT_ROLE {
  NORMAL = 0,
  OPERATOR = 1,
  DEVELOPER = 2,
  DUMMY = 3,
  PREPARED_ODDSMAKER = 4,
}

export enum BLOCK_REASON {
  NONE = 0,
  ADMIN_CONTROL = 1,
}

export enum SEX_TYPE {
  NO_SET = 0,
  MALE = 1,
  FEMALE = 2,
  UNISEX = 3,
}

export enum MSG_TYPE {
  MSG_NORMAL = 1,
  MSG_NOTICES = 1000,
  MSG_LOGS = 2000,
  MSG_BREAKNEWS = 3000,
}

export enum EVENT_KIND {
  NON_EVENT_TYPE = 0,
  EVENT_TYPE_PERIOD = 1,
  EVENT_TYPE_RESTRICT = 2,
}

export enum EVENT_SERVER_STATUS {
  EVENT_STATUS_CLOSED = 0,
  EVENT_STATUS_WAITTING = 1,
  EVENT_STATUS_PROGRESSING = 2,
  EVENT_STATUS_EXPIRED = 3,
}

export enum SORT_TYPE {
  SORT_NONE = 0,
  SORT_BIGGER = 1,
  SORT_HIGHER = 2,
}

export enum ITEM_APPLY_TYPE {
  ITEM_APPLY_INSTANT = 1,
  ITEM_APPLY_PERIOD = 2,
  ITEM_APPLY_MIXED = 3,
}

export enum LIST_FLAG {
  LIST_BEGIN = 0,
  LIST_CONTINUE = 1,
  LIST_END = 2,
}

export enum EVENT_MAINTAIN_TYPE {
  EVENT_MAINTAIN_NONE = 0,
  EVENT_MAINTAIN_DAILY = 1,
  EVENT_MAINTAIN_PERIOD = 2,
  EVENT_MAINTAIN_REPEAT = 3,
}

export enum ITEM_ACTIVATION {
  UNKNOWN = 0,
  UNIQUE = 1,
  MULTI = 2,
}

export enum KICK_REASON {
  UNKNOWN = 0,
  JUST_KICK = 1,
  ANOTHER_LOGIN = 2,
  BLOCK = 3,
  GAMEMONEY_LOSE_LIMIT = 4,
  USER_LOGOUT = 5,
  NETWORK_STOP = 6,
  USER_UNREGISTER = 7,
}

export enum ITEM_CONTAINER {
  UNKNOWN = 0,
  SYSTEM = 1,
  BAG = 2,
  MAIL = 3,
}

export enum ITEM_STATE {
  HOLD = 0,
  NORMAL = 1,
  ACTIVATED = 2,
  USED = 3,
  EXPIRED = 4,
  OVERLAPPED = 5,
  RECOVER = 6,
}

export enum USAGE_LIMIT {
  UNLIMITED = 0,
  LEVEL_LIMITED = 1,
  TIME_LIMITED = 2,
  SYSTEM_LIMITED = 3,
}

export enum EVENT_TYPE {
  UNKNOWN = 0,
  LOGIN = 1,
  COUPON = 2,
  IAB = 3,
  GAMERESULT = 4,
  FIRST_SALE = 5,
}

export enum MISSION_PERIOD_TYPE {
  DAILY = 0,
  WEEKLY = 1,
  CHALLENGE = 2,
  ONCE = 3,
  INFINITE = 4,
}

export enum BET_MONEYINPUT_TYPE {
  SINGLE = 0,
  SINGLE_ALL = 1,
  MULTI = 2,
}

export enum DEMOGRAPHIC_LOG_TYPE {
  UNKNOWN = 0,
  REGISTER = 1,
  LOGIN = 2,
  LOGOUT = 3,
  DROPOUT = 4,
}

export enum IAB_STORE_CODE {
  UNKNOWN = 0,
  GOOGLE = 1,
  NAVER = 2,
  TSTORE = 3,
}

export enum REGULATION_TYPE {
  NO_ERR = 0,
  MUST_IDENTIFICATION_IN_1_MONTH = 1,
  MUST_IDENTIFICATION_IN_2_MONTH = 2,
  MUST_IDENTIFICATION_IN_3_MONTH = 3,
  MUST_IDENTIFICATION_NOW = 4,
  CASH_CHARGE_MONTH_OVER = 5,
  CASH_LOSS_DAILY_OVER = 6,
  CASH_GAME_ROUND_OVER = 7,
  CASH_LUCKY_CHANCE_EXIPREDATE_OVER = 8,
}

export enum SALE_TAG {
  NO = 0,
  EVENT = 1,
  NEW = 2,
  HOT = 3,
  BONUS = 4,
}

export enum LEADERBOARD_TYPE {
  NONE = 0,
  BETTOR_RP = 1,
  PICKSTER_RP = 2,
  CLUB_RP = 3,
  EVENT_PROFIT = 4,
}

export enum LEADERBOARD_ACTOR {
  USER = 0,
  CLUB = 1,
}

export enum PROPERTY_ID {
  NONE = 0,
  CASH = 1,
  MILEAGE = 2,
  POINT = 3,
  MONEY = 4,
  HEART = 5,
  JOB = 6,
  EXP = 7,
  LEVEL = 8,
  CLUB_PENALTY = 9,
  CLUB_OPEN_BLOCK = 10,
  COURT_CLUB_LICENSE = 18,
  ARENA_CLUB_LICENSE = 19,
  STADIUM_CLUB_LICENSE = 20,
  BETTING_COMMISION = 50,
  MESSAGE = 51,
  AVATAR = 52,
  BET_TICKET_1 = 72,
  BET_TICKET_2 = 73,
  BET_TICKET_3 = 74,
  NEW_BET_TICKET_G = 75,
  DIA = 81,
  LICENSE = 100,
  CLUB_MEMBERSHIP = 101,
  COUPON_OPEN_PICKSTER_ROOM = 102,
  COUPON_CHANGE_NICKNAME = 103,
  COUPON_CHANGE_CLUBNAME = 104,
  COUPON_CLUB_MESSAGE = 105,
  COUPON_OPEN_TRAINING_CENTER = 106,
  COUPON_BETTOR_BETTING_COMMISION = 107,
  COUPON_CLUB_BETTING_COMMISION = 108,
  EXP_BOOST = 109,
  PACKAGE = 110,
  COSTUM = 111,
  COUPON_CANCEL_BETTING = 112,
  LIVE_LICENSE = 120,
  APHRODITE = 130,
  ATHENA = 131,
  APOLLON = 132,
  POSEIDON = 133,
  ZEUS = 134,
}

export enum COSTUME_ID {
  NONE = 0,
  HEAD = 1,
  FACEPAINTING = 2,
  GLASSES = 3,
  EARRING = 4,
}

export enum LICENSE_ID {
  NONE = 0,
  FREE = 1,
  COURT = 2,
  ARENA = 3,
  STADIUM = 4,
}

export enum CLUB_MEMBERSHIP_ID {
  NONE = 0,
  FREE = 1,
  COURT = 2,
  ARENA = 3,
  STADIUM = 4,
}

export enum ITEM_CONSUME_TYPE {
  IMMORTAL = 0,
  QUANTITY = 1,
  ACTIVE_PERIOD = 2,
  PASSIVE_PERIOD = 3,
}

export enum ITEM_USAGE_TYPE {
  INSTANT = 0,
  NORMAL = 1,
  ACTIVE = 2,
  PASSIVE = 3,
  ACTIVE_AUTO = 4,
}

export enum ITEM_QUANTITY_TYPE {
  QUANTITY = 0,
  VOLUME = 1,
}

export enum GAME_STATUS {
  AVAILABLE = 0,
  RESERVED = 1,
  PLAYING = 2,
}

export enum FRIEND_STATE {
  FRIEND = 0,
  REQUEST_SENT = 1,
  REQUEST_RECEIVED = 2,
  REQUEST_REFUSED = 3,
}

export enum JOB_TYPE {
  NONE = 0,
  BETTOR = 1,
  ODDSMAKER = 2,
}

export enum CLUB_STATE {
  NONE = 0,
  SEEK_APPROVAL = 1,
  APPROVAL_DENIED = 2,
  APPROVED = 3,
  AGREED = 4,
  PAUSED = 5,
  RUNNING = 6,
  CLOSING = 7,
  CLOSED = 8,
}

export enum CLUB_CLOSING_REASON {
  NONE = 0,
  SEEK_CLOSE = 1,
  EXPIRED = 2,
  ADMIN = 3,
}

export enum CLUB_PAUSE_REASON {
  NONE = 0,
  SEEK_PAUSE = 1,
  EXPIRED = 2,
  ADMIN = 3,
}

export enum CLUB_MEMBER_STATE {
  NONE = 0,
  SEEK_MEMBER = 1,
  DENIED = 2,
  APPROVED = 3,
  MEMBER = 4,
  SELF_OUT = 5,
}

export enum CLUB_CANCEL_OPTION {
  WITHIN_5 = 0,
  WITHIN_30 = 1,
  WITHIN_60 = 2,
}

export enum CLUB_EVENT_TYPE {
  NONE = 0,
  PROFIT = 1,
  YOUTUBE_CHANNEL = 2,
}

export enum SEEK_TYPE {
  NONE = 0,
  JOIN_CLUB = 1,
}

export enum BET_HIT_STATE {
  ONGOING = 0,
  SUCCESS = 1,
  FAIL = 2,
  CANCEL = 3,
}

export enum BET_CALL_TYPE {
  SINGLE = 0,
  MULTI = 1,
}

export enum BET_TYPE_ON {
  MATCH = 0,
  LIVE = 1,
  SPECIAL = 2,
  UNIFIED_MATCH = 3,
  UNIFIED_LIVE = 4,
  UNIFIED_SPECIAL = 5,
  MIX = 6,
}

export enum BET_CANCEL_TYPE {
  NONE = 0,
  BY_BETTOR = 1,
  BY_CLUB = 2,
}

export enum BET_FOLD_CANCEL_TYPE {
  BY_TIME_BALANCE = 0,
}

export enum MATCHUP_CATEGORY {
  CROSS = 0,
  WIN_DRAW_LOSE = 1,
  HANDICAP = 2,
  LIVE = 3,
  MATCH_DETAIL = 4,
  LIVE_DETAIL = 5,
  SPECIAL = 6,
  MIX = 7,
}

export enum MATCHUP_TAB_CATEGORY {
  CROSS = 0,
  WIN_DRAW_LOSE = 1,
  HANDICAP = 2,
  LIVE = 3,
  SPECIAL = 4,
  MATCHUP_RESULT = 5,
}

export enum MATCHUP_WAY {
  UNKNOWN = 0,
  WIN = 1,
  DRAW = 2,
  LOSE = 3,
}

export enum MATCHUP_CATEGORY_FOR_UI_MOBILE {
  CROSS = 0,
  WIN_DRAW_LOSE = 1,
  HANDICAP = 2,
  LIVE = 3,
  MATCH_DETAIL = 4,
  LIVE_DETAIL = 5,
  SPECIAL = 6,
  CROSS_SINGLE_ON = 7,
}

export enum CLUB_NOTICE_TYPE {
  NOTICE = 0,
  EVENT = 1,
}

export enum TERM {
  NONE = 0,
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  YEAR = 4,
  TOTAL = 5,
}

export enum SEEK_APPROVE_TYPE {
  APPROVAL = 0,
  AUTO = 1,
  DENY = 2,
}

export enum TERM_SEEK {
  TODAY = 0,
  WEEK = 1,
  MONTH = 2,
  TWOMONTH = 3,
  BETWEEN = 4,
}

export enum PICK_TYPE {
  PUBLISH = 0,
  PURCHASE = 1,
  DATA = 2,
  MARKET = 3,
}

export enum MY_PICK_REQUEST {
  ALL = 0,
  ONGOING = 1,
  CLOSED = 2,
  HIT = 3,
  FAIL = 4,
}

export enum MY_PICK_FILTER {
  DATE_REGISTER = 0,
  DATE_BETTING = 1,
  SALE_COUNT = 2,
  PRICE = 3,
  DIVIDEND_RATE = 4,
  FOLD_COUNT = 5,
}

export enum MARKET_PICK_FILTER {
  DATE_REGISTER = 0,
  DATE_BETTING = 1,
  SALE_COUNT = 2,
  PRICE = 3,
  DIVIDEND_RATE = 4,
  FOLD_COUNT = 5,
}

export enum LIST_ORDER {
  ASCENDING = 0,
  DESCENDING = 1,
}

export enum CHARGE_TYPE {
  ALL = 0,
  FREE = 1,
  CHARGE = 2,
}

export enum SEARCH_BETTOR_FILTER {
  LEVEL = 0,
  HIT_RATIO = 1,
}

export enum SEARCH_CLUB_TYPE {
  ALL = 0,
  MONEY = 1,
  HEART = 2,
}

export enum SEARCH_CLUB_FILTER {
  DATE_OPEN = 0,
  VISITOR = 1,
  ASSET = 2,
  SOLUBLE = 3,
}

export enum SEARCH_BET_LIST_STATE {
  ALL = 0,
  ONGOING = 1,
  CLOSED = 2,
}

export enum SEARCH_BET_LIST_FILTER {
  DATE_BET = 0,
  DIVIDEND_RATE = 1,
  FOLD_COUNT = 2,
  DIVIDEND_MONEY = 3,
  BET_MONEY = 4,
  DIVIDEND_HEART = 5,
  BET_HEART = 6,
}

export enum MESSAGE_TYPE {
  SYSTEM = 0,
  NORMAL = 1,
  CLUB_INVITE = 2,
  GIFT = 3,
  REWARD = 4,
  NOTICE = 5,
  PICKSTER_INVITE = 6,
  GAME_REWARD = 7,
  MEMBER_TO_CLUB = 8,
  CLUB_TO_MEMBER = 9,
  CLUB_TO_ALL_MEMBER = 10,
  OTHER_TO_CLUB = 11,
  MSG_ONLY_RECV = 12,
  AD_MSG_SEND = 13,
  AD_MSG_RECV = 14,
  PICK_ADD = 15,
  BETTING_HISTORY_SHARE = 16,
}

export enum MESSAGE_DIR {
  SEND = 0,
  RECV = 1,
}

export enum PROPERTY_MOVE_TYPE {
  CONSUME = 0,
  CHARGE = 1,
  EXCHANGE = 2,
}

export enum PROPERTY_CONSUME_TYPE {
  DEFAULT = 0,
  BUY_PRODUCT = 1,
  PRESENT_PRODUCT = 2,
  BUY_PICK = 3,
  BETTOR_BETTING = 4,
  BETTOR_BETTING_COMMISION = 5,
  CLUB_DEPOSIT = 6,
  BETTOR_BETTING_ROLLBACK = 7,
  PRESENT = 8,
  DONATION = 9,
  ADMIN = 10,
  NONMEMBER_CLUB_MESSAGE = 11,
  BIN_BETTING = 12,
  PICK_ADD_MSG_PAY = 13,
  BINARY_ACTIVE_PAY = 14,
  BET_TICKET_ROLLBACK = 15,
  BET_HIT_SUCCESS = 33,
  BET_HIT_FAIL = 34,
  BET_HIT_CANCEL = 35,
  RECOVER = 36,
  ACCOUNT_PROPERTY_WITHDRAW = 37,
  BACCARAT_BETTING = 38,
  ADMIN_CASINO = 39,
}

export enum PROPERTY_CHARGE_TYPE {
  DEFAULT = 0,
  PG_DEPOSIT = 1,
  PG_VIRTUAL_ACCOUNT = 2,
  PG_MOBILE = 3,
  PG_CREDIT_CARD = 4,
  PG_CULTURE_GIFT_CARD = 5,
  PG_SMART_GIFT_CARD = 6,
  PG_BOOK_GIFT_CARD = 7,
  PG_MOBILE_TMONEY = 8,
  PG_TRANSFER = 9,
  PG_CASHBE = 10,
  PG_HAPPY_MONEY = 11,
  PG_FUNNY_CARD = 12,
  COMMON_BEGIN = 32,
  BETTOR_BETTING_HIT = 33,
  BETTOR_BETTING_EXCEPTION = 34,
  BETTOR_BETTING_CANCEL = 35,
  BETTOR_ODDS_CANCEL = 36,
  CLUB_WITHDRAW = 37,
  BETTOR_BETTING_ROLLBACK = 38,
  EVENT = 39,
  GIFT_BOX = 40,
  COUPON = 41,
  MISSION = 42,
  BUY_PRODUCT = 43,
  PRESENT_PRODUCT = 44,
  BUY_PRODUCT_BONUS = 45,
  SELL_PICK = 46,
  PRESENT = 47,
  DONATION = 48,
  ADMIN = 49,
  BIN_BETTING_HIT = 50,
  BIN_BETTING_CANCEL = 51,
  BET_TICKET_USE = 52,
  BETTING_CANCEL_COMMISION = 53,
  ACCOUNT_PROPERTY_DEPOSIT = 54,
  BACCARAT_WIN = 55,
  BACCARAT_RETURN = 56,
  ADMIN_CASINO = 57,
  CASINO_EVENT = 58,
  DOUBLE_ROULETTE = 59,
  CASINO_MISSION = 60,
  FRIEND_INVITATION_REWARD = 61,
  DAILY_BETTING_EVENT_REWARD = 62,
  GOOGLE_INAPP = 100,
}

export enum CLUB_ASSET_RECORD {
  DEPOSIT = 0,
  WITHDRAW = 1,
  BETTING_HIT = 2,
  BETTING_FAIL = 3,
  BETTING_ROLLBACK = 4,
  BETTING_CANCEL_COMMISION = 5,
}

export enum COUPON_USAGE {
  PRIVATE_SINGLE = 0,
  PRIVATE_MULTI = 1,
  PUBLIC = 2,
  PRIVATE_BUNDLE = 3,
  TARGET_BUNDLE = 4,
}

export enum COUPON_TYPE {
  BET_TICKET = 0,
  CLUB_COMMISION = 1,
  DIA = 2,
}

export enum SERVER_STATUS {
  NONE = 0,
  NORMAL = 1,
  QA = 2,
  CHECK = 3,
  CLOSING = 4,
}

export enum TARGET_DEVICE {
  ALL = 0,
  PC = 1,
  MOBILE = 2,
}

export enum SYSTEM_EVENT_TYPE {
  NONE = 0,
  TIME_CONDITION = 1,
  TERM_PROFIT = 2,
  DAILY_PROFIT = 3,
  JOIN_CLUB = 4,
}

export enum CLUB_PROVIDE_ACT_TYPE {
  NONE = 0,
  ADD_ACT = 1,
  DEL_ACT = 2,
}

export enum CLUB_PROVIDE_TARGET_TYPE {
  NONE = 0,
  TARGET_SPORT = 1,
  TARGET_CATEGORY = 2,
  TARGET_TOURNAMENT = 3,
}

export enum SIGNUP_CHANNEL {
  UNKNOWN = 0,
  MEMBERSHIP_PC = 1,
  MEMBERSHIP_MOBILE = 2,
  GOOGLE = 3,
  NAVER = 4,
  FACEBOOK = 5,
}

export enum BINARY_BET_LOW_HIGH {
  NONE = 0,
  BET_LOW = 1,
  BET_HIGH = 2,
  BET_EQUAL = 3,
}

export enum BINARY_BET_OPEN_UNDER_OVER {
  NONE = 0,
  UNDER = 1,
  OVER = 2,
  EQUAL = 3,
}

export enum BINARY_BET_ODD_EVEN {
  NONE = 0,
  ODD = 1,
  EVEN = 2,
}

export enum BINARY_BET_DECIMAL_UNDER_OVER {
  NONE = 0,
  DECIMAL_UNDER = 1,
  DECIMAL_OVER = 2,
}

export enum BINARY_GAME_PROCESS_STATE {
  START = 0,
  SUCCESS_RESULT = 1,
  INVALID_RESULT = 2,
}

export enum BINARY_GAME_HIST_TYPE {
  PAST_HOURS = 0,
  A_DAY = 1,
}

export enum TEAM_TYPE {
  NONE = 0,
  HOME = 1,
  AWAY = 2,
}

export enum WINNER_STATE {
  NONE = 0,
  HOME = 1,
  AWAY = 2,
  TIE = 3,
}

export enum BINARY_RESULT {
  NONE = 0,
  BIN_HIT = 1,
  BIN_FAIL = 2,
  BIN_EXCEPT = 3,
}

export enum TUTORIAL_MAX {
  MAX = 10,
}

export enum NOTICE_ANIMATION_TYPE {
  NONE = 0,
  RIGHT_TO_LEFT = 1,
  BLINK = 2,
}

export enum CLUB_BOARD_CATEGORY_TYPE {
  NONE = 0,
  GAME_ANAL = 1,
  PICK_PUB = 2,
  PROUD = 3,
  ANY_TOK = 4,
}

export enum INAPP_CONSUMPTION_STATE {
  PURCHASED = 0,
  CONSUMED = 1,
  UNKNOWN = 64,
}

export enum INAPP_PURCHASE_STATE {
  PURCHASED = 0,
  CANCELED = 1,
  UNKNOWN = 64,
}

export enum INAPP_PURCHASE_TYPE {
  TEST = 0,
  PROMO = 1,
  STANDARD = 32,
  UNKNOWN = 64,
}

export enum RANK_CATEGORY {
  NONE = 0,
  BETTOR_RANK_ALL = 1,
  BETTOR_RANK_SOCCER = 2,
  BETTOR_RANK_BASEBALL = 3,
  BETTOR_RANK_BASKET = 4,
  BETTOR_RANK_VOLLEY = 5,
  BETTOR_RANK_ETC = 6,
  BETTOR_RANK_WIN_DRAW_LOSE = 7,
  BETTOR_RANK_HANDICAP = 8,
  BETTOR_RANK_LIVE = 9,
  BETTOR_RANK_SPECIAL = 10,
  BETTOR_RANK_DETAIL = 11,
  PICKSTER_RANK_PROFIT = 12,
  PICKSTER_RANK_HIT = 13,
  CLUB_RANK_BETNUM = 14,
  CLUB_RANK_VISIT = 15,
  CLUB_RANK_HAVE_MONEY = 16,
  CLUB_RANK_HAVE_HEART = 17,
}

export enum REF_SPORT_ID {
  SP_SOCCER = 1,
  SP_BASKET = 2,
  SP_BASEBALL = 3,
  SP_VOLLEY = 23,
}

export enum SPORT_ID {
  SOCCER = 1,
  BASKETBALL = 2,
  BASEBALL = 3,
  ICE_HOCKEY = 4,
  TENNIS = 5,
  HANDBALL = 6,
  FLOORBALL = 7,
  TROTTING = 8,
  GOLF = 9,
  BOXING = 10,
  MOTORSPORT = 11,
  RUGBY = 12,
  AUSSIE_RULES = 13,
  WINTER_SPORTS = 14,
  BANDY = 15,
  AMERICAN_FOOTBALL = 16,
  CYCLING = 17,
  SPECIALS = 18,
  SNOOKER = 19,
  TABLE_TENNIS = 20,
  CRICKET = 21,
  DARTS = 22,
  VOLLEYBALL = 23,
  FIELD_HOCKEY = 24,
  POOL = 25,
  WATERPOLO = 26,
  GAELIC_SPORTS = 27,
  CURLING = 28,
  FUTSAL = 29,
  OLYMPICS = 30,
  BADMINTON = 31,
  BOWLS = 32,
  CHESS = 33,
  BEACH_VOLLEY = 34,
  NETBALL = 35,
  ATHLETICS = 36,
  SQUASH = 37,
  RINK_HOCKEY = 38,
  LACROSSE = 39,
  FORMULA_1 = 40,
  BIKES = 41,
  DTM = 42,
  ALPINE_SKIING = 43,
  BIATHLON = 44,
  BOBSLEIGH = 45,
  CROSS_COUNTRY = 46,
  NORDIC_COMBINED = 47,
  SKI_JUMPING = 48,
  SNOWBOARD = 49,
  SPEED_SKATING = 50,
  LUGE = 51,
  SWIMMING = 52,
  FINNISH_BASEBALL = 53,
  SOFTBALL = 54,
  HORSE_RACING = 55,
  SCHWINGEN = 56,
  INLINE_HOCKEY = 57,
  GREYHOUND = 58,
  RUGBY_LEAGUE = 59,
  BEACH_SOCCER = 60,
  PESAPALLO = 61,
  STREETHOCKEY = 62,
  WORLD_CHAMPIONSHIP = 63,
  ROWING = 64,
  FREESTYLE = 65,
  SNOWBOARDCROSS_PARALLEL = 66,
  MOTO_GP = 67,
  MOTO_2 = 68,
  MOTO_3 = 69,
  NASCAR_CUP_SERIES = 70,
  PADEL_TENNIS = 71,
  CANOEING = 72,
  HORSEBALL = 73,
  AQUATICS = 74,
  ARCHERY = 75,
  EQUESTRIAN = 76,
  FENCING = 77,
  GYMNASTICS = 78,
  JUDO = 79,
  MODERN_PENTATHLON = 80,
  SAILING = 81,
  SHOOTING = 82,
  TAEKWONDO = 83,
  TRIATHLON = 84,
  WEIGHTLIFTING = 85,
  WRESTLING = 86,
  OLYMPICS_YOUTH = 87,
  MOUNTAIN_BIKE = 88,
  RIDING = 89,
  SURFING = 90,
  BMX_RACING = 91,
  CANOE_SLALOM = 92,
  RHYTHMIC_GYMNASTICS = 93,
  TRAMPOLINE_GYMNASTICS = 94,
  ARTISTIC_SWIMMING = 95,
  DIVING = 96,
  TRACK_CYCLING = 97,
  BEACH_TENNIS = 98,
  SUMO = 99,
  SUPERBIKE = 100,
  RALLY = 101,
  FIGURE_SKATING = 102,
  FREESTYLE_SKIING = 103,
  SKELETON = 104,
  SHORT_TRACK = 105,
  SOCCER_MYTHICAL = 106,
  E_SPORT = 107,
  WORLD_LOTTERY = 108,
  COUNTER_STRIKE = 109,
  LEAGUE_OF_LEGENDS = 110,
  DOTA_2 = 111,
  STAR_CRAFT = 112,
  HEARTHSTONE = 113,
  HEROES_OF_THE_STORM = 114,
  WORLD_OF_TANKS = 115,
  POLO = 116,
  MMA = 117,
  CALL_OF_DUTY = 118,
  SMITE = 119,
  VAINGLORY = 120,
  OVERWATCH = 121,
  WAR_CRAFT_III = 122,
  CROSSFIRE = 123,
  HALO = 124,
  RAINBOW_SIX = 125,
  SEPAK_TAKRAW = 126,
  STREET_FIGHTER_V = 127,
  ROCKET_LEAGUE = 128,
  INDY_RACING = 129,
  BASQUE_PELOTA = 130,
  SPEEDWAY = 131,
  ESPORT_GEARS_OF_WAR = 132,
  ESPORT_CLASH_ROYALE = 133,
  ESPORT_KING_OF_GLORY = 134,
  GAELIC_FOOTBALL = 135,
  GAELIC_HURLING = 136,
  E_SOCCER = 137,
  KABADDI = 138,
  ESPORT_QUAKE = 139,
  ESPORT_PLAYER_UNKNOWNS_BATTLEGROUNDS = 140,
  CYCLING_CYCLE_BALL = 141,
  FORMULA_E = 142,
  SEVEN_BALL_RUN = 143,
  MOTOCROSS = 144,
  SPRINT_CAR_RACING = 145,
  SPEED_BOAT_RACING = 146,
  DRAG_RACING = 147,
  STOCK_CAR_RACING_1 = 148,
  MODIFIED_RACING = 149,
  OFF_ROAD = 150,
  TRUCK_AND_TRACTOR_PULLING = 151,
  ESPORT_WORLD_OF_WARCRAFT = 152,
  E_BASKETBALL = 153,
  ESPORT_DRAGON_BALL_FIGHTER_Z = 154,
  BASKETBALL_3_X_3 = 155,
  ESPORT_TEKKEN = 156,
  BEACH_HANDBALL = 157,
  ESPORT_ARENA_OF_VALOR = 158,
  ESPORT_TF_2 = 159,
  ESPORT_SSBM = 160,
  ESPORT_PALADINS = 161,
  ESPORT_ARTIFACT = 162,
  INDOOR_SOCCER = 163,
  ESPORT_APEX_LEGENDS = 164,
  INDY_LIGHTS = 165,
  ESPORT_PRO_EVOLUTION_SOCCER = 166,
  ESPORT_MADDEN_NFL = 167,
  ESPORT_BRAWL_STARS = 168,
  PETANQUE = 169,
  ESPORT_FORTNITE = 170,
  ESPORT_MTG = 171,
  FISHING = 172,
  ESPORT_DOTA_UNDERLORDS = 173,
  ESPORT_TEAMFIGHT_TACTICS = 174,
  ESPORT_AUTO_CHESS = 175,
  ESPORT_FIGHTING_GAMES = 176,
  DEPRECATED_SC = 177,
  ESPORT_MOTORSPORT = 178,
  CYCLING_BMX_FREESTYLE = 179,
  CYCLING_BMX_RACING = 180,
  KARATE = 181,
  MARATHON_SWIMMING = 182,
  SKATEBOARDING = 183,
  SPORT_CLIMBING = 184,
  NASCAR_CAMPING_WORLD_TRUCK = 185,
  NASCAR_XFINITY_SERIES = 186,
  NHRA = 187,
  TOURING_CAR_RACING = 188,
  FORMULA_2 = 189,
  MOTORCYCLE_RACING = 190,
  STOCK_CAR_RACING_2 = 191,
  AIR_RACING = 192,
  ENDURANCE_RACING = 193,
  ESPORT_VALORANT = 194,
  E_ICE_HOCKEY = 195,
  E_TENNIS = 196,
  ECRICKET = 197,
  EVOLLEYBALL = 198,
}

export enum LS_SPORT_ID {
  UNKNOWN = 0,
  BEACH_VOLLEYBALL = 621569,
  TABLE_TENNIS = 265917,
  FUTSAL = 687887,
  HORSE_RACING = 687888,
  GOLF = 687889,
  E_GAMES = 687890,
  GREYHOUNDS = 687893,
  TROTTING = 687894,
  SPEEDWAY = 687895,
  FOOTBALL = 6046,
  BASKETBALL = 48242,
  MOTOGP = 687896,
  CHESS = 687897,
  VOLLEYBALL = 154830,
  ICE_HOCKEY = 35232,
  CRICKET = 452674,
  EQUINE_SPORTS = 291987,
  AUSTRALIAN_RULES = 389537,
  BADMINTON = 1149093,
  FORMULA_1 = 1149094,
  NASCAR = 1149095,
  HOCKEY = 530129,
  SUPERCARS = 1149096,
  NETBALL = 1149097,
  SURFING = 1149098,
  CYCLING = 1149099,
  GAELIC_SPORTS = 1149100,
  BIATHLON = 1149101,
  MOTORBIKES = 1149102,
  ATHLETICS = 1149103,
  SQUASH = 1149104,
  BASKETBALL_3X3 = 1149105,
  FLOOR_BALL = 35706,
  SUMO = 1149107,
  VIRTUAL_SPORTS = 1149108,
  HANDBALL = 35709,
  POLITICS = 1149109,
  WEATHER = 1149110,
  TV_GAMES = 1149111,
  LOTTERY = 1149112,
  BOWLS = 1149113,
  POKER = 1149114,
  WATER_POLO = 388764,
  ALPINE_SKIING = 261354,
  SAILING = 1149115,
  HURLING = 1149117,
  SKI_JUMPING = 1149118,
  INDY = 1149119,
  LACROSSE = 1149120,
  BANDY = 46957,
  MOTOR_SPORTS = 165874,
  BASEBALL = 154914,
  RUGBY_UNION = 274791,
  RUGBY_LEAGUE = 274792,
  CURLING = 307126,
  BOXING = 154919,
  DARTS = 154923,
  TENNIS = 54094,
  AMERICAN_FOOTBALL = 131506,
  SNOOKER = 262622,
}

export enum BINARY_GRAPH_TYPE {
  NONE = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  AVERAGE = 4,
}

export enum BINARY_GAME_TYPE {
  NONE = 0,
  BITCOIN = 100000001,
  BIT_THERMO = 100000002,
  BIT_RABBIT = 100000003,
}

export enum BINARY_SPORT_INFO {
  SPORT_ID = 100000001,
  CATEGORY_ID = 1,
  TOURNAMENT_ID = 1,
}

export enum BINARY_THERMO_INFO {
  SPORT_ID = 100000002,
  CATEGORY_ID = 1,
  TOURNAMENT_ID = 1,
}

export enum BINARY_RABBIT_INFO {
  SPORT_ID = 100000003,
  CATEGORY_ID = 1,
  TOURNAMENT_ID = 1,
}

export enum GAME_TYPE {
  SPORTS = 0,
  BINARY = 1,
}

export enum SAS_ROLE {
  NONE = 0,
  DISTRIBUTOR = 1,
  WORKER = 2,
  DUAL = 3,
}

export enum SAS_DISTRIBUTOR_STATE {
  NORMAL = 0,
  PAUSED = 1,
  DROPPED = 2,
}

export enum SAS_DISTRIBUTOR_LEVEL {
  UNKNOWN = 0,
  ADMIN = 1,
  LARGE = 2,
  MEDIUM = 3,
  SMALL = 4,
  MIN = 1,
  MAX = 4,
}

export enum CHAT_TYPE {
  USER_CHAT = 0,
  USER_SHARE_1 = 1,
  USER_SHARE_2 = 2,
  SYS_INFO_1 = 3,
  SYS_INFO_2 = 4,
  SYS_INFO_3 = 5,
  SYS_ADMIN_1 = 6,
  SYS_ADMIN_2 = 7,
  SYS_ADMIN_3 = 8,
  NOTICE_REFRESH_1 = 9,
}

export enum CHAT_BLOCK_TYPE {
  CHAT_FREE = 0,
  CHAT_BLOCK_TIME = 1,
  CHAT_BLOCK_TIME_5M = 2,
  CHAT_BLOCK_TIME_10M = 3,
  CHAT_BLOCK_TIME_30M = 4,
  CHAT_BLOCK_TIME_60M = 5,
  CHAT_BLOCK_EVER = 6,
}

export enum BANNER_UPDATE_ACT {
  ADD = 0,
  MODIFY = 1,
}

export enum BANNER_TYPE {
  JUST_IMAGE = 0,
  SPECAIL_BINARY = 1,
  SPORT_MATCH = 2,
}

export enum PRODUCT_EDITION_TYPE {
  NORMAL_FREE = 0,
  TIME_CONDITION = 1,
}

export enum ASSET_TYPE {
  CASH = 0,
  MONEY = 1,
  HEART = 2,
  POINT = 3,
  MILEAGE = 4,
  BET_TICKET = 5,
  DIA = 6,
}

export enum BET_MONEY_TYPE {
  G_MONEY = 4,
  HEART = 5,
  G_TICKET = 75,
  DIA = 81,
}

export enum MARKET_RENDERING_TYPE {
  TYPE_1 = 1,
  TYPE_2 = 2,
  TYPE_3 = 3,
  TYPE_4 = 4,
  TYPE_5 = 5,
  TYPE_6 = 6,
  TYPE_7 = 7,
  TYPE_8 = 8,
}

export enum MATCH_STATUS {
  NotStarted = 0,
  FirstPeriod = 1,
  SecondPeriod = 2,
  ThirdPeriod = 3,
  FourthPeriod = 4,
  FifthPeriod = 5,
  FirstHalf = 6,
  SecondHalf = 7,
  FirstSet = 8,
  SecondSet = 9,
  ThirdSet = 10,
  FourthSet = 11,
  FifthSet = 12,
  FirstQuarter = 13,
  SecondQuarter = 14,
  ThirdQuarter = 15,
  FourthQuarter = 16,
  GoldenSet = 17,
  Started = 20,
  InProgress = 21,
  AboutToStart = 22,
  Break = 30,
  Halftime = 31,
  AwaitingExtraTime = 32,
  ExtraTimeHalftime = 33,
  AwaitingPenalties = 34,
  AwaitingGoldenSet = 37,
  Overtime = 40,
  FirstExtra = 41,
  SecondExtra = 42,
  Penalties = 50,
  Postponed = 60,
  StartDelayed = 61,
  Cancelled = 70,
  Game1 = 71,
  Game2 = 72,
  Game3 = 73,
  Game4 = 74,
  Game5 = 75,
  Game6 = 76,
  Game7 = 77,
  Interrupted = 80,
  Suspended = 81,
  Abandoned = 90,
  Walkover = 91,
  Retired = 92,
  Walkover_Player1Won = 93,
  Walkover_Player2Won = 94,
  Player1Retired_Player2Won = 95,
  Player2Retired_Player1Won = 96,
  Player1Defaulted_Player2Won = 97,
  Player2Defaulted_Player1Won = 98,
  OnlyResult = 99,
  Ended = 100,
  AET = 110,
  AOT = 111,
  AP = 120,
  AfterGoldenSet = 130,
  FirstMap = 141,
  SecondMap = 142,
  ThirdMap = 143,
  FourthMap = 144,
  FifthMap = 145,
  SixthMap = 146,
  FirstGame = 151,
  SecondGame = 152,
  ThirdGame = 153,
  FourthGame = 154,
  FifthGame = 155,
  FirstEnd = 161,
  SecondEnd = 162,
  ThirdEnd = 163,
  FourthEnd = 164,
  FifthEnd = 165,
  SixthEnd = 166,
  SeventhEnd = 167,
  EighthEnd = 168,
  NinthEnd = 169,
  TenthEnd = 170,
  ExtraEnd = 171,
  FirstBreak = 301,
  SecondBreak = 302,
  ThirdBreak = 303,
  FourthBreak = 304,
  FifthBreak = 305,
  SixthBreak = 306,
  FirstInningTop = 401,
  FirstInningBottom = 402,
  SecondInningTop = 403,
  SecondInningBottom = 404,
  ThirdInningTop = 405,
  ThirdInningBottom = 406,
  FourthInningTop = 407,
  FourthInningBottom = 408,
  FifthInningTop = 409,
  FifthInningBottom = 410,
  SixthInningTop = 411,
  SixthInningBottom = 412,
  SeventhInningTop = 413,
  SeventhInningBottom = 414,
  EighthInningTop = 415,
  EighthInningBottom = 416,
  NinthInningTop = 417,
  NinthInningBottom = 418,
  ExtraInningTop = 419,
  ExtraInningBottom = 420,
  BreakTop1_Bottom1 = 421,
  BreakTop2_Bottom1 = 422,
  BreakTop2_Bottom2 = 423,
  BreakTop3_Bottom2 = 424,
  BreakTop3_Bottom3 = 425,
  BreakTop4_Bottom3 = 426,
  BreakTop4_Bottom4 = 427,
  BreakTop5_Bottom4 = 428,
  BreakTop5_Bottom5 = 429,
  BreakTop6_Bottom5 = 430,
  BreakTop6_Bottom6 = 431,
  BreakTop7_Bottom6 = 432,
  BreakTop7_Bottom7 = 433,
  BreakTop8_Bottom7 = 434,
  BreakTop8_Bottom8 = 435,
  BreakTop9_Bottom8 = 436,
  BreakTop9_Bottom9 = 437,
  BreakTopEI_Bottom9 = 438,
  BreakTopEI_BottomEI = 439,
  SuddenDeath = 440,
  SixthSet = 441,
  SeventhSet = 442,
  AwaitingSuddenDeath = 443,
  AfterSuddenDeath = 444,
  Break2 = 445,
  FirstInnings_HomeTeam = 501,
  FirstInnings_AwayTeam = 502,
  SecondInnings_HomeTeam = 503,
  SecondInnings_AwayTeam = 504,
  AwaitingSuperOver = 505,
  SuperOver_HomeTeam = 506,
  SuperOver_AwayTeam = 507,
  AfterSuperOver = 508,
  InningsBreak = 509,
  SuperOverBreak = 510,
  LaunchBreak = 511,
  TeaBreak = 512,
  Stumps = 513,
  EighthSet = 514,
  NinthSet = 515,
  TenthSet = 516,
  EleventhSet = 517,
  TwelfthSet = 518,
  ThirteenthSet = 519,
  ThirdInning_HomeTeam = 520,
  ThirdInnings_AwayTeam = 521,
  FourthInnings_HomeTeam = 522,
  FourthInnings_AwayTeam = 523,
  DinnerBreak = 524,
  Drinks = 525,
  SuperOver = 526,
  FirstInning = 531,
  SecondInning = 532,
  ThirdInning = 533,
  FourthInning = 534,
  FifthInning = 535,
  SixthInning = 536,
  SeventhInning = 537,
  EighthInning = 538,
  NinthInning = 539,
  BreakTopEI_Bottom7 = 548,
}

export enum LS_MATCH_STATUS {
  NOT_START_YET = 0,
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  FINISHED = 3,
  CANCELLED = 4,
  POSTPONED = 5,
  INTERRUPTED = 6,
  ABANDONED = 7,
  COVERAGE_LOST = 8,
  ABOUT_TO_START = 9,
  OVERTIME_FIRST_HALF = 30,
  OVERTIME_SECOND_HALF = 35,
  OVERTIME = 40,
  PENALTIES = 50,
  GOLDEN_SET = 51,
  IN_PROGRESS_PERIOD = 52,
  GAME = 60,
  ERROR = 62,
  ROUND = 65,
  FRAME = 66,
  LEG = 67,
  OVER = 70,
  DELIVERY = 71,
  BREAK_TIME = 80,
  NONE = 90,
  FULL_TIME = 100,
  FULL_TIME_AFTER_OVERTIME = 101,
  FULL_TIME_AFTER_PENALTIES = 102,
  HALFTIME = 201,
  OVERTIME_HALFTIME = 202,
  HOME_PARTICIPANT_HAS_RETRIED = 203,
  AWAY_PARTICIPANT_HAS_RETRIED = 204,
  COVERAGE_FOR_THIS_EVENT_HAS_BEEN_LOST = 205,
  MEDICAL_TIMEOUT = 206,
  TIMEOUT_OF_HOME_TEAM = 207,
  TIMEOUT_OF_AWAY_TEAM = 208,
  TIMEOUT = 209,
  HOME_WALKOVER = 210,
  AWAY_WALKOVER = 211,
  FIRST_QUARTER = 111,
  SECOND_QUARTER = 112,
  THIRD_QUARTER = 113,
  FOURTH_QUARTER = 114,
  FIRST_GAME = 121,
  SECOND_GAME = 122,
  THIRD_GAME = 123,
  FOURTH_GAME = 124,
  FIFTH_GAME = 125,
  FIRST_HALF = 131,
  SECOND_HALF = 132,
  FIRST_INNING = 141,
  SECOND_INNING = 142,
  THIRD_INNING = 143,
  FOURTH_INNING = 144,
  FIFTH_INNING = 145,
  SIXTH_INNING = 146,
  SEVENTH_INNING = 147,
  EIGHTH_INNING = 148,
  NINTH_INNING = 149,
  FIRST_SET = 151,
  SECOND_SET = 152,
  THIRD_SET = 153,
  FOURTH_SET = 154,
  FIFTH_SET = 155,
  SIXTH_SET = 156,
  SEVENTH_SET = 157,
  FIRST_MAP = 161,
  SECOND_MAP = 162,
  THIRD_MAP = 163,
  FOURTH_MAP = 164,
  FIFTH_MAP = 165,
  FIRST_PERIOD = 171,
  SECOND_PERIOD = 172,
  THIRD_PERIOD = 173,
}

export enum MATCH_GAME_STATUS {
  NotStarted = 0,
  Live = 1,
  Ended = 3,
  Closed = 4,
  Cancelled = 5,
}

export enum TERMS_TYPE {
  SERVICE = 1,
  PRIVATE_POLICY = 2,
  SNS = 3,
}

export enum AUTHENTICATION_TYPE {
  NONE = 0,
  PHONE = 1,
  I_PIN = 2,
}

export enum PLAY_BLOCK_TYPE {
  NONE = 0,
  LOSS_LIMIT_EXCEEDED = 1,
  SELF_SET_USAGE_RESTRICTIONS = 2,
}

export enum EXTRA_ODDS_TYPE {
  NONE = 0,
  GOD_BLESS_ITEM = 1,
}

export enum EXTRA_ODDS_ITEM_PROPERTY {
  APHRODITE = 130,
  ATHENA = 131,
  APOLLON = 132,
  POSEIDON = 133,
  ZEUS = 134,
}

export enum RECEIVE_ITEM_FAIL_TYPE {
  UNKNOWN = 0,
  MAX_COUNT_EXCEED = 1,
}